// Copyright (c) 2016 Deere & Company

import './navigation-list.scss';
import React, {PropTypes} from 'react';
import NavigationItem from './navigation-item';

const NavigationList = ({includeFavorites, parentRoute, routes}) =>
    <ul className='navigation-list'>
        {routes.map((route, index) =>
            <NavigationItem
                includeFavorites={includeFavorites}
                key={index}
                label={route.name}
                path={`${parentRoute}/${route.path}`}
            />)
        }
    </ul>

;

NavigationList.displayName = 'NavigationList';
NavigationList.propTypes = {
    includeFavorites: PropTypes.bool.isRequired,
    parentRoute: PropTypes.string.isRequired,
    routes: PropTypes.array.isRequired
};
NavigationList.defaultProps = {
    includeFavorites: true
};

export default NavigationList;




// WEBPACK FOOTER //
// ./src/shared/components/navigation-list/index.js